import '../pages/App.css';
import Navbar from '../Components/Navbar/Navbar';
import Body from '../Components/Body/Body';
import Footer from '../Components/Footer/Footer';


function App() {
  return (
    <div>
      <Navbar/>
      <Body/>
      <Footer/>
    </div>
  );
}

export default App;
